import { FieldBase } from '@/components/form/fieldBase';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { ColorPickerDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/ColorPickerDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { MarkierungType } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';

export function ColorPickerFormField({
  form,
  isMobile,
}: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form.AppField name="markierung">
      {(field) => {
        const handleChange = (value: MarkierungType) => {
          field.handleChange(value);
          field.handleBlur();
        };

        return (
          <FieldBase
            label={t('domain.termine.form.fields.farbe')}
            className="w-fit">
            <>
              {isMobile ? (
                <ColorPickerDrawer
                  value={field.state.value}
                  onChange={handleChange}
                />
              ) : (
                <ColorPicker
                  value={field.state.value}
                  onChange={handleChange}
                />
              )}
            </>
          </FieldBase>
        );
      }}
    </form.AppField>
  );
}
